// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Admin Debit / Credit Transactions */
.admintrans-section {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid var(--border);
  overflow: hidden;
}

.admintrans-section__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.25rem 1.5rem;
  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);
  border-bottom: 1px solid var(--border);
}

.admintrans-section__title-wrap {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.admintrans-section__icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.15);
  color: #0f766e;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.admintrans-section__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text);
}

.admintrans-section__stats {
  display: flex;
  gap: 1.25rem;
}

.admintrans-section__stats--actions {
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
}

.admintrans-export-btn {
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 700;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(22, 101, 52, 0.35);
  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);
  color: #166534;
  cursor: pointer;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  transition: background 0.2s, box-shadow 0.2s;
}

.admintrans-export-btn:hover:not(:disabled) {
  background: #dcfce7;
  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);
}

.admintrans-export-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.admintrans-toast {
  position: fixed;
  top: 1.25rem;
  right: 1.25rem;
  z-index: 1200;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  border-radius: 10px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.admintrans-toast--success {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.admintrans-toast--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.admintrans-stat {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.admintrans-stat strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.25rem;
}

.admintrans-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.75rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border);
}

.admintrans-search-wrap i {
  color: var(--text-muted);
  font-size: 0.9rem;
}

.admintrans-search-input {
  flex: 1 1;
  min-width: 0;
  max-width: 400px;
  padding: 0.55rem 0.75rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.admintrans-search-input::placeholder {
  color: var(--text-muted);
}

.admintrans-search-input:focus {
  outline: none;
  border-color: #0f766e;
}

.admintrans-table-wrap {
  overflow-x: auto;
}

.admintrans-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.admintrans-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background: #f8fafc;
}

.admintrans-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  border-bottom: 2px solid #e2e8f0;
  white-space: nowrap;
}

.admintrans-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.admintrans-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.admintrans-table tbody tr:hover {
  background: #f0fdfa !important;
}

.admintrans-table tbody tr:last-child td {
  border-bottom: none;
}

.admintrans-mono {
  font-family: ui-monospace, monospace;
  font-size: 0.8rem;
  color: #0369a1;
  font-weight: 500;
}

.admintrans-type {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  font-size: 0.72rem;
  font-weight: 600;
}

.admintrans-type--credit {
  background: #dcfce7;
  color: #166534;
}

.admintrans-type--debit {
  background: #fef2f2;
  color: #b91c1c;
}

.admintrans-type--neutral {
  background: #f1f5f9;
  color: #475569;
}

.admintrans-admin {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.admintrans-empty {
  padding: 2rem 1.5rem;
  text-align: center;
  color: var(--text-muted);
  font-size: 0.9rem;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Exchange/AdminDebitCreditPage.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX","sourcesContent":["/* Admin Debit / Credit Transactions */\n.admintrans-section {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  border: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.admintrans-section__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding: 1.25rem 1.5rem;\n  background: linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%);\n  border-bottom: 1px solid var(--border);\n}\n\n.admintrans-section__title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.admintrans-section__icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.15);\n  color: #0f766e;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.admintrans-section__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text);\n}\n\n.admintrans-section__stats {\n  display: flex;\n  gap: 1.25rem;\n}\n\n.admintrans-section__stats--actions {\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.admintrans-export-btn {\n  font-family: inherit;\n  font-size: 0.85rem;\n  font-weight: 700;\n  padding: 0.5rem 1rem;\n  border-radius: 8px;\n  border: 1px solid rgba(22, 101, 52, 0.35);\n  background: linear-gradient(180deg, #fff 0%, #f0fdf4 100%);\n  color: #166534;\n  cursor: pointer;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  transition: background 0.2s, box-shadow 0.2s;\n}\n\n.admintrans-export-btn:hover:not(:disabled) {\n  background: #dcfce7;\n  box-shadow: 0 2px 8px rgba(22, 101, 52, 0.15);\n}\n\n.admintrans-export-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.admintrans-toast {\n  position: fixed;\n  top: 1.25rem;\n  right: 1.25rem;\n  z-index: 1200;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n}\n\n.admintrans-toast--success {\n  background: #f0fdf4;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.admintrans-toast--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.admintrans-stat {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.admintrans-stat strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.25rem;\n}\n\n.admintrans-search-wrap {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 0.75rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border);\n}\n\n.admintrans-search-wrap i {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n}\n\n.admintrans-search-input {\n  flex: 1;\n  min-width: 0;\n  max-width: 400px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.admintrans-search-input::placeholder {\n  color: var(--text-muted);\n}\n\n.admintrans-search-input:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.admintrans-table-wrap {\n  overflow-x: auto;\n}\n\n.admintrans-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.admintrans-table thead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: #f8fafc;\n}\n\n.admintrans-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  border-bottom: 2px solid #e2e8f0;\n  white-space: nowrap;\n}\n\n.admintrans-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.admintrans-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.admintrans-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.admintrans-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admintrans-mono {\n  font-family: ui-monospace, monospace;\n  font-size: 0.8rem;\n  color: #0369a1;\n  font-weight: 500;\n}\n\n.admintrans-type {\n  display: inline-block;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.72rem;\n  font-weight: 600;\n}\n\n.admintrans-type--credit {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.admintrans-type--debit {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.admintrans-type--neutral {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.admintrans-admin {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.admintrans-empty {\n  padding: 2rem 1.5rem;\n  text-align: center;\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
